import React, { FC, useMemo } from 'react';
import styled from 'styled-components';
import { GetChargeResult } from '@sdir/httpclient/lib/clients/aps/application';
import { styles } from '@sdir/sds';
import { useIntl } from 'react-intl';

type ArticleInfoProps = {
  article: GetChargeResult;
};

export const ArticleInfo: FC<ArticleInfoProps> = ({ article }) => {
  const intl = useIntl();
  const amountText = useMemo(() => {
    if (!article.amount) return intl.formatMessage({ id: 'summarystep.charge.unknownamount' });
    const formattedAmount = intl.formatNumber(article.amount, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
    return `${formattedAmount} NOK`;
  }, [article.amount, intl]);

  return (
    <StyledTable>
      <thead>
        <tr>
          <th>{intl.formatMessage({ id: 'summarystep.charge' })}</th>
          <th>{intl.formatMessage({ id: 'summarystep.charge.amount' })}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{article.name}</td>
          <td>{amountText}</td>
        </tr>
      </tbody>
    </StyledTable>
  );
};

const StyledTable = styled.table`
  width: 100%;
  border-spacing: 0;

  thead {
    font-size: 16px;
    font-family: ${styles.fonts.stfMedium};
    line-height: 1;
    font-weight: normal;

    th {
      padding: 8px 0;
    }
  }

  td,
  th {
    text-align: left;
  }

  tbody {
    font-size: 16px;
    font-family: ${styles.fonts.stfBook};
    line-height: 1;
    font-weight: normal;

    td {
      border-radius: 6px;
      padding: 24px;
      padding-left: 0;
      background: ${styles.colors.primary10};
      color: ${styles.colors.font.text};

      &:first-child {
        border-radius: 6px 0 0 6px;
        padding-left: 24px;
      }

      &:last-child {
        border-radius: 0 6px 6px 0;
      }
    }
  }
`;
